export default __webpack_public_path__ + "fonts/reason-img5.svg";